import { gql } from '@apollo/client';

export const PERMISSION_FIELDS = gql`
    fragment PermissionFields on permissions {
        client_id
        created_at
        entity_id
        entity_type
        last_modified_at
        permission_id
        permission_type
        scope
    }
`;
